import { Shop } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSignedIfAdmin } from './fetchFromApi';

export const fetchContext = () =>
  fetchFromApiSignedIfAdmin<Shop>(`${getParams().context}s/${getParams().contextId}`, {
    fullData: true,
  });
